import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Mail, ArrowRight } from "lucide-react";
import client, { formatApiError } from "@/lib/api";
import { useLang } from "@/context/LangContext";
import { AuthShell, Field } from "@/pages/Login";

export default function Forgot() {
  const { t } = useLang();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await client.post("/auth/forgot-password", { email: email.trim(), origin_url: window.location.origin, lang: localStorage.getItem("melletic_lang") || "en" });
      setSent(true);
      toast.success(t("reset_sent"));
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title={t("reset_title")} subtitle={t("reset_sub")}>
      {sent ? (
        <div className="glass rounded-2xl p-6 text-center">
          <p className="text-slate-200">{t("reset_sent")}</p>
          <Link to="/login" className="inline-block mt-4 text-cyan-300 font-semibold">{t("back_login")}</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <Field icon={Mail} type="email" required placeholder={t("email_ph")} value={email}
            onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" />
          <button disabled={loading} data-testid="forgot-submit"
            className="w-full mel-gradient text-white font-semibold py-4 rounded-2xl shadow-[0_14px_34px_-14px_rgba(37,99,235,0.8)] flex items-center justify-center gap-2 disabled:opacity-60 press">
            {loading ? t("sending") : <>{t("send_reset")} <ArrowRight size={18} /></>}
          </button>
          <p className="text-center text-slate-400 mt-4">
            <Link to="/login" className="text-cyan-300 font-semibold">{t("back_login")}</Link>
          </p>
        </form>
      )}
    </AuthShell>
  );
}
